import { useRef } from 'react';
import axios from 'axios';
import MainURL from '../../MainURL';
import ResumeEdit from '../../screens/mypage/pages/resume/ResumeEdit';
import { ADMIN_RESUME_ACCOUNT, adminResumeSignWriter } from './adminResume';
import { MOCK_FILL_SOURCES, buildMockFill } from './mockResumeFill';
import './MinisterManage.scss';

// 이미 DB 에 저장된 관리자 작성 이력서 제목 — 같은 목데이터를 두 번 채우지 않도록
async function fetchRegisteredTitles() {
  const res = await axios.get<{ success: boolean; list?: { userAccount: string; title: string }[] }>(
    `${MainURL}/resume/adminlist`,
  );
  if (!res.data?.success || !Array.isArray(res.data.list)) throw new Error('INVALID_RESPONSE');
  return new Set(res.data.list.filter((row) => row.userAccount === ADMIN_RESUME_ACCOUNT).map((row) => row.title));
}

// 이력서 작성(resumeId 없음) / 관리자 작성 이력서 수정(resumeId 있음) — 마이페이지 이력서 작성 화면 재사용
export default function AdminResumeWrite({ resumeId, onDone }: { resumeId?: string; onDone: () => void }) {
  // 저장하지 않고 다시 누르면 다음 사람으로 넘어가도록, 이번에 채웠던 목데이터 순번을 기억
  const shownRef = useRef<Set<number>>(new Set());

  const handleAiFill = async () => {
    let registered: Set<string>;
    try {
      registered = await fetchRegisteredTitles();
    } catch (err) {
      console.error('failed to load registered resumes:', err);
      alert('등록된 이력서 목록을 불러오지 못했습니다.');
      return null;
    }

    const remaining = MOCK_FILL_SOURCES.map((_, index) => index).filter(
      (index) => !registered.has(MOCK_FILL_SOURCES[index].title),
    );
    if (remaining.length === 0) {
      alert(`사역자 정보 목데이터 ${MOCK_FILL_SOURCES.length}건이 모두 등록되었습니다.`);
      return null;
    }

    let candidates = remaining.filter((index) => !shownRef.current.has(index));
    if (candidates.length === 0) {
      shownRef.current.clear();
      candidates = remaining;
    }
    const index = candidates[0];
    shownRef.current.add(index);
    return buildMockFill(index);
  };

  return (
    <div className="admin-resume-write">
      <p className="minister-manage__hint">
        관리자 계정으로 저장되며, 이력서 관리 목록과 상단 「사역자 정보」에 노출됩니다. (회원 마이페이지에는 표시되지 않습니다)
        {!resumeId && (
          <>
            <br />
            「AI작성하기」를 누르면 사역자 정보 페이지의 샘플 데이터({MOCK_FILL_SOURCES.length}건) 중 아직 등록되지 않은 1건이 사진과 함께 채워집니다.
          </>
        )}
      </p>
      <ResumeEdit
        admin={{
          userAccount: ADMIN_RESUME_ACCOUNT,
          signWriter: adminResumeSignWriter(),
          resumeId,
          onDone,
          onAiFill: resumeId ? undefined : handleAiFill,
        }}
      />
    </div>
  );
}
